(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(function() {
            return factory(root);
        });
    } else if (typeof exports === 'object') {
        module.exports = factory;
    } else {
        root.CustomSelect = factory(root);
    }
})(this, function (root) {

    'use strict';

    var VERSION = "1.0";
    //lodash dependency
    var _ = window._;

    var init = function() {
        var $customSelects = $('.j-customSelect');
        if ($customSelects.length > 0) {
            _.each($customSelects,function (item) {
                new CustomSelect($(item));
            });
        }
    };

    return {
        VERSION:VERSION
    };

});